import _typeof from "E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import moment from '../filters';
import $moment from 'moment-timezone';

/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (time == 0 || time == "") {
    return "";
  }
  time = time / 1000;
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if (_typeof(time) === 'object') {
    date = $moment.tz(time, "Asia/Tokyo");
  } else {
    if (('' + time).length >= 9) {
      time = parseInt(time) * 1000;
    }
    date = $moment.tz(time, "Asia/Tokyo");
  }
  var formatObj = {
    y: date.get("year"),
    m: date.get("month") + 1,
    d: date.get("date"),
    h: date.get('hour'),
    i: date.get('minute'),
    s: date.get('second'),
    a: date.days()
  };
  var time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return time_str;
}